<template>
  <v-app id="inspire">
    <v-main>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
          v-if="!changeElem"
        >
          <v-col
            cols="12"
            sm="10"
            md="4"
          >
            <v-card outlined>
              <v-toolbar
                light
                flat
              >
                <v-spacer />
                <div class="mt-10">
                  <p class="text-center headline">
                    <v-icon
                      color="#00ACDC"
                      class="mx-2"
                    >
                      mdi-account-plus
                    </v-icon>Register
                  </p>
                </div>
                <div class="flex-grow-1" />
              </v-toolbar>
              <v-alert
                v-model="isError"
                type="error"
                class="mx-7 my-0"
                dismissible
              >
                {{ this.errorMessage }}
              </v-alert>
              <v-card-text class="my-0">
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-container>
                    <v-row>
                      <v-col sm="12">
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Corporate email address"
                          placeholder="e.g. example@mail.com"
                          v-model="emailAddress"
                          :rules="[emailAddressRules.required, emailAddressRules.email]"
                          type="email"
                        />
                      </v-col>
                      <v-col sm="12">
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Full name"
                          v-model="fullname"
                          :rules="fullnameRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                      >
                        <v-combobox
                          hide-details
                          :items="dataTimezone"
                          item-text="value"
                          label="Timezone"
                          outlined
                          v-model="timezone"
                          :rules="timezoneRules"
                          required
                        />
                      </v-col>
                      <v-col
                        sm="12"
                        v-if="isWollongong"
                        class="px-0"
                      >
                        <v-col
                          cols="12"
                          sm="12"
                        >
                          <v-select
                            hide-details
                            :items="rfidTypes"
                            :item-text="(rT) => `${rT.name}`"
                            :item-value="(rT) => `${rT.name}`"
                            label="RFID Type"
                            outlined
                            v-model="rfidType"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          v-if="rfidType"
                        >
                          <v-text-field
                            outlined
                            hide-details
                            color="success"
                            label="Key Cabinet RFID"
                            v-model="keyCabinetRFID"
                          />
                        </v-col>
                      </v-col>
                      <v-col
                        sm="12"
                        class="font-weight-medium"
                        v-if="!isWollongong"
                      >
                        Driver Licence Details
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        v-if="!isWollongong"
                      >
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Issuing state"
                          v-model="issuingState"
                          :rules="issuingStateRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        v-if="!isWollongong"
                      >
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Licence type"
                          v-model="licenseType"
                          :rules="licenseTypeRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        v-if="!isWollongong"
                      >
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Conditions"
                          v-model="conditions"
                          :rules="conditionsRules"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        v-if="!isWollongong"
                      >
                        <v-text-field
                          outlined
                          hide-details
                          color="success"
                          label="Licence no"
                          v-model="licenseNo"
                          :rules="licenseNoRules"
                        />
                      </v-col>
                      <v-col
                        sm="12"
                        v-if="!isWollongong"
                      >
                        <v-menu
                          v-model="isOpenDate"
                          :close-on-content-click="false"
                          max-width="290px"
                          min-width="290px"
                        >
                          <template #activator="{ on, attrs }">
                            <v-text-field
                              :value="expiryDate"
                              outlined
                              clearable
                              label="Expiry date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              @click:clear="date = null"
                              :rules="expiryDateRules"
                              hide-details
                            />
                          </template>
                          <v-date-picker
                            v-model="expiryDate"
                            @change="isOpenDate = false"
                          />
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        class="my-0"
                      >
                        <v-combobox
                          v-model="assetGroup"
                          :items="assetGroups"
                          item-text="name"
                          item-value="id"
                          label="Asset Group"
                          multiple
                          outlined
                          required
                          hide-details
                          :rules="[(v) => v.length ? null : 'Please select at least one group!']"
                        >
                          <template #selection="{ item, index }">
                            <v-chip v-if="index === 0">
                              <span>{{ item.name }}</span>
                            </v-chip>
                            <span
                              v-if="index === 1"
                              class="grey--text caption"
                            >
                              (+{{ assetGroup.length - 1 }} others)
                            </span>
                          </template>
                        </v-combobox>
                      </v-col>
                      <v-col sm="12">
                        <div
                          v-if="isCopp"
                          class="licence-info"
                        >
                          Note:
                          <br>
                          <i>Kindly submit a photo copy of your drivers licence to <a href="mailto: poolcar@yarracity.vic.gov.au">poolcar@yarracity.vic.gov.au</a></i>
                        </div>
                        <v-file-input
                          v-if="!isCopp && !isWollongong"
                          v-model="upload_photo"
                          label="Upload your Licence photo"
                          outlined
                          prepend-icon=""
                          hide-details
                          type="file"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-btn
                  block
                  color="#00ACDC"
                  outlined
                  @click="register"
                  :loading="loadingUpdate"
                  :disable="loadingUpdate"
                >
                  Register
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          align="center"
          justify="center"
          v-else
        >
          <v-col
            cols="12"
            sm="10"
            md="4"
          >
            <v-card outlined>
              <v-img
                class="mx-auto mt-10"
                max-height="200"
                max-width="200"
                :src="logoB"
              />
              <v-card-title class="justify-center headline font-weight-medium">
                Register Success
              </v-card-title>
              <v-card-subtitle class="text-center font-weight-regular title">
                Please wait for admin approval email, contact admin if you have not received email within 48 hours.
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// const qs = require("qs");
const get = require("lodash/get");

export default {
  props: {
    source: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    dialog: false,
    isOpenDate: false,
    emailAddress: "",
    fullname: "",
    issuingState: "",
    licenseType: "",
    conditions: "",
    licenseNo: "",
    expiryDate: "",
    emailAddressRules: {
      required: value => !!value || 'Required.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      },
    },
    fullnameRules: [(v) => !!v || "Fullname is required"],
    issuingStateRules: [(v) => !!v || "Issuing state is required"],
    licenseTypeRules: [(v) => !!v || "Licence type is required"],
    conditionsRules: [(v) => !!v || "Conditions is required"],
    licenseNoRules: [(v) => !!v || "Licence no is required"],
    expiryDateRules: [(v) => !!v || "Expiry date is required"],
    keyRules: [(v) => !!v || "Key Cabinet RFID is required"],
    valid: true,
    isError: false,
    errorMessage: "",
    upload_photo: [],
    uploadPhotoRequired: false,
    loadingUpdate: false,
    loader: null,
    changeElem: false,
    assetGroup: [],
    assetGroups: [],
    rfidTypes: [
      {
        name: 'RFID Card'
      },
      {
        name: 'RFID Key Ring'
      },
      {
        name: 'RFID Sticker'
      }
    ],
    rfidType: 'RFID Card',
    keyCabinetRFID: '',
    dataTimezone: [],
    timezoneRules: [(v) => !!v || "Timezone is required"],
    timezone: "",
  }),
  created() {
    this.getAssetGroups();
    this.getTimezone();
  },
  mounted() {
    this.emailAddress = this.$route.query.email || '';
  },
  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    },
  },
  methods: {
    getTimezone() {
      this.$store.dispatch('API_CALL', {
        $method: 'get_timezone'
      })
        .then((response) => {
          this.dataTimezone = response.data.data;
          if (this.isOmaha) {
            this.timezone = this.dataTimezone.find(tz => tz.value == 'Central Standard Time');
          } else {
            this.timezone = this.dataTimezone.find(tz => tz.value == 'AUS Eastern Standard Time');
          }
        });
    },
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    isRestricted(asset) {
      const isRestrictedDay = get(asset, 'metadata.working_hours', []).length > 0;
      const workingTime = get(asset, 'metadata.working_time', { start: '' , end: ''});
      const isRestrictedTime = workingTime.start !== '' && workingTime.end !== '';
      return isRestrictedDay || isRestrictedTime;
    },
    getAssetGroups() {
      this.$store.dispatch('API_CALL', {
          $method: 'get_asset_groups',
          $postData: {
            clientid: this.$store.state.user.user.clientid,
            hash: this.$route.params.hash,
          },
        })
        .then((response) => {
          this.assetGroups = response.data.data.filter((group) => {
            const isRestricted = group.members.find(member => this.isRestricted(member));
            const noBookingRequired = this.getValueAsBoolean(group.metadata.no_booking_required);
            const isSpecial = this.getValueAsBoolean(get(group, 'metadata.is_special', false));
            const isRestrictedGroup = noBookingRequired && isRestricted;
            return !isRestrictedGroup && !isSpecial;
          });
          if (this.isWollongong) {
            this.issuingState = 'NSW';
            this.licenseType = 'Vehicle / Car';
            this.conditions = 'All';
            this.expiryDate = '2050-01-01';
            this.licenseNo = '-';
            this.assetGroup = this.assetGroups.filter(g => g.name == 'Carpool');
          }
        });
    },
    register() {
      if (this.$refs.form.validate()) {
          const { hash } = this.$route.params;
          const payloads = {
            hash,
            email: this.emailAddress,
            fullname: this.fullname,
            timezone: this.timezone.value,
            driver_license: {
              issuing_state: this.issuingState,
              license_type: this.licenseType,
              conditions: this.conditions,
              license_no: this.licenseNo,
              expiry_date: this.expiryDate,
            },
            photo: this.upload_photo,
            asset_group: this.assetGroup.map((group) => group.id).join(',')
          };

          if (this.isWollongong) {
            payloads.rfid_type = this.rfidType;
            payloads.key_cabinet_rfid = this.keyCabinetRFID;
          }

          this.loadingUpdate = true;
          this.loader = this.loadingUpdate;

          this.$store.dispatch("REGISTER", payloads).then(() => {
            if (this.$store.state.error == true) {
              this.dialog = false;
              this.isError = true;
              this.errorMessage = this.$store.state.errorMsg;
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
            } else {
              this.$refs.form.reset();
              this.changeElem = true;
              this.loadingUpdate = false;
              this.loader = this.loadingUpdate;
              setTimeout(() => {
                this.$router.push({path: '/login'});
              }, 5000);
            }
          });
      }
    },
    closeAndClear() {
      this.$refs.form.reset();
      this.dialog = false;
    },
  },
  computed: {
    logoB() {
      return process.env.VUE_APP_LOGO_B;
    },
    isCopp() {
      return this.$route.params.hash == 'bd9855c3b55808ceacb71acff5e01dfe8d018b5745216bdf94c29d2fe7b1509f';
    },
    isWollongong() {
      return this.$route.params.hash == 'e3c49736fab3606571148fc723e9ee37c22934a410886bb51cc4dc5d05e2010d';
    },
    isOmaha() {
      return this.$route.params.hash == 'd700e2362df090158fbc4db7a094f34dce6ba618bf36816205cf0232db212e55';
    }
  },
};
</script>

<style>
.licence-info {
  font-weight: bold;
}
</style>